<template>
  <div>
    <div class="b-page__title-wrap pt-4 px-6">
      <div class="b-contract__card-data-wrap">
        <a @click="goBack()" class="b-contract__card-data-back mt-2">
          <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="back"></dynamic-icon>
        </a>
        <div class="b-contract__card-data-main">
          <div class="row">
            <div class="col-12">
              <div class="row px-0">
                <div class="col-7">
                  <div class="b-contract__card-data-info-about-wrap mb-5">
                    <div class="b-contract__card-data-title-wrap">
                      <h1 class="mb-1 ">{{$tc('CONTENT.contract.contract', 1)}} № {{number}}
                        <div class="b-contract__card-data-title-inner">
                          {{$t('CONTENT.from')}} {{currentContract.date | dateFormatted}}
                          <button
                            v-if="isAltContractRawEditing"
                            @click="openCardDataPopupClick"
                            class="b-btn b-btn_border_none b-btn_type_icon_accent_color"
                          >
                            <dynamic-icon class="b-btn__icon" icon="edit"></dynamic-icon>
                          </button>
                        </div>
                      </h1>
                    </div>
                    <div class="b-edit-card__info-about-row mb-2">
                      <div class="col-8 px-0 b-contract_row_flex b-contract__secondary-text">
                        <div v-if="idInDb" class="mr-3">id: {{idInDb}}</div>
                        <div v-if="externalId" class="">{{$t('CONTENT.external_id_small')}}: {{externalId}}</div>
                      </div>
                    </div>
                    <div class="b-edit-card__info-about-row mb-2">
                      <div class="col-8 px-0 b-contract_row_flex b-contract__secondary-text">
                        <div v-if="responsible" class="">{{$t('CONTENT.contract.initiator')}}: {{responsible}}</div>
                      </div>
                    </div>
                    <div v-if="externalLink" class="b-edit-card__info-about-row mb-2">
                      <div class="col-8 px-0 b-contract_row_flex b-contract__secondary-text">
                        {{$t('CONTENT.contract.externalLink')}}: &nbsp;<a :href="externalLink" target="_blank" class="mr-3">{{externalLinkName}}</a>
                      </div>
                    </div>
                    <div v-if="prolongationType" class="b-edit-card__info-about-row mb-2">
                      <div class="col-8 px-0 b-contract_row_flex b-contract__secondary-text">
                        {{$t('CONTENT.contract.prolongationType')}}: {{prolongationType}}
                      </div>
                    </div>
                    <div class="col-8 px-0 b-contract__card-data-info-about mb-2">
                      <div class="b-contract__card-data-info-about-row-name mb-1">{{$t('CONTENT.contract.lessee')}}:</div>
                      <div class="b-contract__card-data-info-about-row-value">
                        {{lessee}}
                        <div
                          class="b-counterparty-content__info-checked-item ml-1"
                          v-if="checkIsCounterpartyIntragroup(currentContract.lesseeId)"
                        >
                          <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
                        </div>
                      </div>
                    </div>
                    <div class="col-8 px-0 b-edit-card__info-about" v-if="lessors.length > 0">
                      <div class="b-contract__card-data-info-about-row-name mb-1">{{$t('CONTENT.contract.lessor')}}:</div>
                      <template v-for="item in lessors">
                        <div class="b-contract__card-data-info-about-row-value">
                          {{item.name}}
                          <div
                            class="b-counterparty-content__info-checked-item ml-1"
                            v-if="checkIsCounterpartyLessorIntragroup(item.id)"
                          >
                            <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
                          </div>
                        </div>
                      </template>
                    </div>
                    <ul class="b-contract__card-data-info-about-list col-8 px-0 mt-3">
                      <li class="ml-4 mt-1" v-if="isLowValue">{{$t('CONTENT.contract.is_low_value')}}</li>
                      <li class="ml-4 mt-1" v-if="isExceptionToArticle3OfIFRS16">{{$t('CONTENT.contract.isExceptionToArticle3OfIFRS16')}}</li>
                      <li class="ml-4 mt-1" v-if="isIrrelevant">{{$t('CONTENT.contract.isIrrelevant')}}</li>
                      <li class="ml-4 mt-1" v-if="isNotRentContract">{{$t('CONTENT.contract.isNotRentContract')}}</li>
                      <li class="ml-4 mt-1" v-if="isShortTerm">{{$t('CONTENT.contract.isShortTerm')}}</li>
                      <li class="ml-4 mt-1" v-if="isVariableLeasePayments">{{$t('CONTENT.contract.isVariableLeasePayments')}}</li>
                    </ul>
                  </div>
                </div>
                <div class="col-5">
                  <div class="b-contract__edit-btns mt-2 mr-2" >
                    <template v-if="!this.isAltContractRawEditing">
                      <button
                        data-cy="edit-button"
                        class="b-btn b-btn__icon_color_main-text"
                        @click="onClickEditContract"
                      >
                        <dynamic-icon icon="edit" class="b-btn__icon"></dynamic-icon>
                        {{$t('CONTENT.contract.edit')}}
                      </button>
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="b-btn b-btn_type_empty ml-6"
                        @click="cancelContractChange"
                      >{{$t('CONTENT.cancel')}}</button>
                      <button
                        type="button"
                        class="b-btn b-btn_type_primary ml-6"
                        @click="saveAltContract"
                      >{{$t('CONTENT.save')}}</button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="currentContract.periodSpendings.length > 0">
      <div class="col-8">
        <div class="mt-6 mx-17 b-contract__card-data-periods">
          <div class="b-contract__card-data-title-wrap">
            <h2>{{$t('CONTENT.contract.period_sprendings_title')}}</h2>
            <div class="b-contract__card-data-title-inner">
              <button
                v-if="isAltContractRawEditing"
                @click="openPeriodSpendingsPopupClick"
                class="b-btn b-btn_border_none b-btn_type_icon_accent_color"
              >
                <dynamic-icon class="b-btn__icon" icon="edit"></dynamic-icon>
              </button>
            </div>
          </div>
          <div class="b-page__title-wrap py-4 px-6 mt-4">
            <div class="b-contract__card-data-info-about-wrap">
              <div class="row b-form__container_type_flex">
                <div class="col-4 b-contract__card-data-info-about-row-name mb-2">{{$t('CONTENT.contract.period')}}</div>
                <div class="col-4 b-contract__card-data-info-about-row-name mb-2">{{$t('CONTENT.sum')}}</div>
              </div>
              <div class="mt-1">
                <div class="row b-form__container_type_flex" v-for="item in periodSpendings">
                  <div class="col-4">{{item.startDate | dateFormatted}} - {{item.endDate | dateFormatted}}</div>
                  <div class="col-4">{{item.sum}} {{currencyCode}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="currentContract.lowValueAssets.length > 0">
      <div class="col-8" v-for="item in currentContract.lowValueAssets">
        <div class="mt-6 mx-17 b-contract__card-data-periods">
          <div class="b-contract__card-data-title-wrap">
            <h2>{{getAssetName(item.assetId)}}</h2>
            <div class="b-contract__card-data-title-inner">
              <button
                v-if="isAltContractRawEditing"
                @click="openLowValueAssetsPopupClick(item)"
                class="b-btn b-btn_border_none b-btn_type_icon_accent_color"
              >
                <dynamic-icon class="b-btn__icon" icon="edit"></dynamic-icon>
              </button>
            </div>
          </div>
          <div class="b-page__title-wrap py-4 px-6 mt-4">
            <div class="b-contract__card-data-info-about-wrap">
              <div class="row b-form__container_type_flex">
                <div class="col-4 b-contract__card-data-info-about-row-name mb-2">{{$t('CONTENT.contract.period')}}</div>
                <div class="col-4 b-contract__card-data-info-about-row-name mb-2">{{$t('CONTENT.sum')}}</div>
              </div>
              <div class="mt-1">
                <div class="row b-form__container_type_flex" v-for="period in item.periodSpendings">
                  <div class="col-4">{{period.startDate | dateFormatted}} - {{period.endDate | dateFormatted}}</div>
                  <div class="col-4">{{period.sum}} {{currencyCode}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dateConverter from "../../../../utils/converters/date.converter";
import AltCardDataPopup from "./rawEditing/AltCardDataPopup";

  export default {
    components: {
      AltCardDataPopup,
    },
    props: {
      currentContract: {
        type: Object,
      },
      prevRoute: {
        type: String,
      },
    },
    data() {
      return {
        isContractEditing: false,
        totalCost: null,
        liabilitiesDate: null,
      }
    },
    computed: {
      ...mapGetters(["getAltContractState"]),
      ...mapGetters(['allCounterparties']),
      ...mapGetters(['getContractSettings']),
      ...mapGetters(['getCurrentContract']),
      ...mapGetters(['getUnderlyingAssetTypes']),
      ...mapGetters(['getAssets']),
      isAltContractRawEditing() {
        return this.getAltContractState;
      },
      currencyCode() {
        return this.getContractSettings.currencyCode;
      },
      assets() {
        return this.getCurrentContract.assets;
      },
      contractSettingsCurrencyCode() {
        return this.getContractSettings.currencyCode;
      },
      number() {
        return this.currentContract.number;
      },
      idInDb() {
        return this.currentContract.idInDb;
      },
      externalId() {
        return this.currentContract.externalId;
      },
      externalLink() {
        return this.currentContract.externalLink;
      },
      externalLinkName() {
        return this.currentContract.externalLinkName;
      },
      prolongationType() {
        return this.currentContract.prolongationType;
      },
      responsible() {
        return this.currentContract.responsible;
      },
      lessee() {
        for (let i = 0; i < this.allCounterparties.length; i++) {
          if(this.allCounterparties[i].idInDB === this.currentContract.lesseeId) {
            return this.allCounterparties[i].displayName;
          }
        }
      },
      lessors() {
        let lessors = [];
        for (let i = 0; i < this.allCounterparties.length; i++) {
          for (let j = 0; j < this.currentContract.lessorIds.length; j++) {
            if (
              this.allCounterparties[i].idInDB ===
              this.currentContract.lessorIds[j]
            ) {
              lessors.push({
                name: this.allCounterparties[i].displayName,
                id: this.allCounterparties[i].idInDB
              });
            }
          }
        }
        return lessors;
      },
      isLowValue() {
        return this.currentContract.isLowValue;
      },
      isExceptionToArticle3OfIFRS16() {
        return this.currentContract.isExceptionToArticle3OfIFRS16;
      },
      isIrrelevant() {
        return this.currentContract.isIrrelevant;
      },
      isNotRentContract() {
        return this.currentContract.isNotRentContract;
      },
      isShortTerm() {
        return this.currentContract.isShortTerm;
      },
      isVariableLeasePayments() {
        return this.currentContract.isVariableLeasePayments;
      },
      periodSpendings() {
        return this.currentContract.periodSpendings;
      }
    },
    methods: {
      onClickEditContract() {
        this.$store.commit("SET_ALT_CONTRACT_CHANGE_CONDITION_STATE", true);
      },
      cancelContractChange() {
        this.$store.commit("SET_ALT_CONTRACT_CHANGE_CONDITION_STATE", false);
      },
      openCardDataPopupClick() {
        this.$emit("onClickEditCardData");
      },
      openPeriodSpendingsPopupClick() {
        this.$emit("onClickEditPeriodSpendings");
      },
      openLowValueAssetsPopupClick(lowValueAsset) {
        this.$emit("onClickEditLowValueAssets", lowValueAsset);
      },
      async saveAltContract() {
        this.$emit("onClickSaveEditContract");
      },
      checkIsCounterpartyIntragroup(counterpartyId) {
        for (let i = 0; i < this.allCounterparties.length; i++) {
          if (this.allCounterparties[i].idInDB === counterpartyId) {
            return this.allCounterparties[i].isIntragroupTurnover;
          }
        }
      },
      checkIsCounterpartyLessorIntragroup(counterpartyId) {
        for (let i = 0; i < this.allCounterparties.length; i++) {
          if (this.allCounterparties[i].idInDB === counterpartyId) {
            return this.allCounterparties[i].isIntragroupTurnover;
          }
        }
      },
      getAssetName(assetId) {
        for (let i = 0; i < this.getAssets.length; i++) {
          if(this.getAssets[i].idInDB === assetId) {
            let assetType = this.getAssetType(this.getAssets[i].underlyingAssetTypeId);
            return `${assetType}. ${this.getAssets[i].name}`;
          }
        }
      },
      getAssetType(assetTypeId) {
        for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
          if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
            return this.getUnderlyingAssetTypes[i].name;
          }
        }
      },
      goBack() {
        this.$router.push({path: this.prevRoute})
      }
    },
  };
</script>
